// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","791":"2d0c6a1e","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"2e2d365eb39e6d23d289","532":"da52a24ad2f345e15fa0","678":"9187c5d0300714a177de","791":"be484aaade19a183a674","883":"edf95c1cd878d8778f71"}[chunkId] + ".js";
};